export enum ClaimsEnum {
    LegalAdAdmin = "LegalAdAdmin",
    LegalAdCorpSystems = "LegalAdCorpSystems",
    LegalAdApprove = "LegalAdApprove",
    LegalAdRequest = "LegalAdRequest"
}